/* src/shared/ui/Button/Button.tsx */
import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/utils/cn';
import styles from './Button.module.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'outline' | 'quaternary' | 'on-solid' | 'destructive';
  size?: 'xs' | 's' | 'm';
  iconOnly?: boolean;
  asChild?: boolean;
}

function getHoverMotion(variant: NonNullable<ButtonProps['variant']>) {
  switch (variant) {
    case 'destructive':
      return 'stable';
    default:
      return 'layered';
  }
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'm', iconOnly = false, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(styles.button, className)}
        data-hover-motion={getHoverMotion(variant)}
        data-variant={variant}
        data-size={size}
        data-icon-only={iconOnly || undefined}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };
